import React from 'react';
import { Map } from 'lucide-react';

function DiscoveryActions() {
  return (
    <div className="flex flex-wrap items-center justify-end gap-2">
      <span className="inline-flex items-center gap-1 rounded-lg border border-white/20 bg-white/10 px-2.5 py-1 text-xs text-primary-content/80">
        <Map className="h-3.5 w-3.5" aria-hidden="true" />
        Map view available
      </span>
    </div>
  );
}

export default DiscoveryActions;